//@flow
import styled from 'styled-components';
import { FlexRow } from 'styles/Layout';
import { HeaderIcons } from 'utils/ExportCommon';
import { media } from 'styles/Mixins';

export const Arrow = styled(HeaderIcons.DownArrow)`
  height: 10px;
  width: 16px;
  margin-right: 20px;
`;

export const ProfileImageLogin = styled(FlexRow)`
  display: flex;
  align-items: center;
`;

export const Option = styled(FlexRow)`
  min-height: 60px; } 
  min-width: 0;
  transition: background-color 0.2s linear;
  cursor: pointer;
  &:hover {
    background-color: #eee;
  }
  display: ${props => (props.hideInMobile ? 'none' : 'flex')};
  ${media.md`
    min-width: 120px;
    display: ${props => (props.hideInDesktop ? 'none' : 'flex')};
  `};
`;

export const LoginDropDownOption = styled(Option)`
  min-height: 35px;
  width: 100%;
  min-width: 100% !important;
  align-items: center;
  font-size: 14px;
  padding: 9px 15px;
  color: #4a4a4a;
  font-size: 14px;
  line-height: 17px;
  user-select: none;
`;

export const ProfileImage = styled.div.attrs({
  style: ({ url }) => ({
    backgroundImage: `url('${url}')`
  })
})`
  display: block;
  height: 30px;
  width: 30px;
  background: 50% no-repeat;
  background-size: cover;
  border-radius: 50%;
  z-index: 4;
  pointer-events: none;
`;

export const FullName = styled.p`
  margin-bottom: 0px;
  margin-left: 3px;
  width: 66px;
  color: #4a4a4a;
  font-size: 14px;
  font-weight: bold;
  line-height: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Divider = styled.div`
  height: 1px;
  background: #ccc;
  width: 100%;
`;

export const LoginContainer = styled(FlexRow)`
  cursor: pointer;
  min-width: 0;
  display: none;
  ${media.md`
    display: flex;
  `};
`;
